import { render, staticRenderFns } from "./step_one.vue?vue&type=template&id=06af6b81&scoped=true"
import script from "./step_one.vue?vue&type=script&lang=js"
export * from "./step_one.vue?vue&type=script&lang=js"
import style0 from "./step_one.vue?vue&type=style&index=0&id=06af6b81&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af6b81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06af6b81')) {
      api.createRecord('06af6b81', component.options)
    } else {
      api.reload('06af6b81', component.options)
    }
    module.hot.accept("./step_one.vue?vue&type=template&id=06af6b81&scoped=true", function () {
      api.rerender('06af6b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/step_one.vue"
export default component.exports